import { get } from 'libs/request';
import getValue from 'lodash/get';
import * as cache from 'utils/cache';
import { API_EC } from 'config/host';
import { checkResponse } from 'libs/utils';
import { counter } from 'utils/slardar';

const LS_ABTEST_PARAMS = 'LS_ABTEST_PARAMS';

export const ORDER_SHOW_SIGNATORY = 'order_show_signatory';

/**
 * Get ABTest Params
 * @param platform E.g: aweme
 * @param key ABTest params key
 * @param defaultValue
 */
export async function getAbTestParams(
    platform: string,
    key: string,
    defaultValue: any,
    options?: any
) {
    try {
        let abParamsInfo: any = await cache.get(LS_ABTEST_PARAMS);
        if (!abParamsInfo || typeof abParamsInfo[key] === 'undefined') {
            const response = await get(`${API_EC}/index/getNewAbUiParams?token=${platform}`, {
                timeout: 1000,
                ...(options || {})
            });
            const data = checkResponse(response);
            if (!data) {
                return defaultValue;
            }

            abParamsInfo = data.temai_ui;

            cache.set(LS_ABTEST_PARAMS, abParamsInfo, {
                expires: Date.now() + 1000 * 60 * 10
            });
        }

        return getValue(abParamsInfo, key, defaultValue);
    } catch (err) {
        counter('error_get_abtest_params', {
            tags: {
                platform,
                key,
                err: err.msg || err.message
            }
        });

        return defaultValue;
    }
}
